import { Icon, type IconName } from '../components/Icon';
import { PageHeader } from '../components/Shell';
import { NavLink } from '../lib/router';
import { SCHEDULE_PATH } from '../lib/navigation';
import { UsagePanel } from '../components/UsagePanel';

const sections: Array<{ title: string; description: string; to: string; icon: IconName }> = [
  { title: 'Outreach controls', description: 'Sending state, shared limits and manual research.', to: '/prospects?panel=outreach', icon: 'email' },
  { title: 'Apollo discovery', description: 'Credential, credit allowance and contact enrichment.', to: '/prospects?panel=apollo', icon: 'search' },
  { title: 'Support mailbox', description: 'Google connection and support conversations. Separate from prospect outreach.', to: '/emails', icon: 'reply' },
  { title: 'Scheduler and agents', description: 'Scheduled jobs, agent runs and execution state.', to: SCHEDULE_PATH, icon: 'clock' },
  { title: 'Metrics and source health', description: 'Observation windows, collection freshness and trends.', to: '/metrics', icon: 'metrics' },
  { title: 'Operating guide', description: 'How research, review, outreach and campaigns work together.', to: '/help', icon: 'help' }
];

export function SettingsPage() {
  return <>
    <PageHeader title="Settings" description="AI usage, connections and operating controls." />
    <UsagePanel />
    <h2 className="settings-connections-heading">Connections &amp; controls</h2>
    <nav className="workspace-settings" aria-label="Settings and connections">
      {sections.map(item => <NavLink to={item.to} key={item.to} className="workspace-settings__link"><Icon name={item.icon} /><span><strong>{item.title}</strong><small>{item.description}</small></span><Icon name="chevronRight" /></NavLink>)}
    </nav>
  </>;
}
